/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';

import BannerHome from '../../components/BannerHome';

import { fetchInsurances } from '../../redux/InsuranceTypes';
import InsuranceCard from '../InsuranceCard';

export default function InsurancesTypes() {
  const dispatch = useDispatch();

  let { insurances, loading, isEmployee } = useSelector(
    ({ insurances, user }) => ({
      isEmployee: user.empleado,
      insurances: insurances.productTypes,
      loading: insurances.loading,
    })
  );

  useEffect(() => {
    dispatch(fetchInsurances());
  }, []);

  const finalInsurances = [];

  if (insurances) {
    insurances.map((insurance) => {
      if (insurance.description.toLowerCase() === 'pertenencias protegidas') {
        const modeledProduct = {
          insuranceCompanies: [
            {
              insuranceCompanyId:
                insurance.insuranceCompanies[0].insuranceCompanyId,
              products: [],
              shortDesc: insurance.insuranceCompanies[0].shortDesc,
            },
          ],
        };

        const ppFinalProducts = [];

        insurance.insuranceCompanies[0].products.map((product) => {
          if (product.insuranceProductDesc.toLowerCase() === 'tecno') {
            modeledProduct.description = product.insuranceProductDesc;
            modeledProduct.insuranceCompanies[0].products.push(product);
          } else {
            ppFinalProducts.push(product);
          }
        });

        const ppFinalProduct = {
          insuranceCompanies: [
            {
              insuranceCompanyId:
                insurance.insuranceCompanies[0].insuranceCompanyId,
              shortDesc: insurance.insuranceCompanies[0].shortDesc,
              products: ppFinalProducts,
            },
          ],
          description: insurance.description,
        };

        ppFinalProduct.insuranceCompanies[0].products = ppFinalProducts;
        finalInsurances.push(modeledProduct, ppFinalProduct);
      } else {
        finalInsurances.push(insurance);
      }
    });
  }

  return (
    <>
      {loading ? (
        'LOADING'
      ) : (
        <Grid
          container
          item
          xs={12}
          spacing={2}
          justify='flex-start'
          style={{ marginTop: 24 }}
        >
          {/* isEmployee &&  */}
          { finalInsurances?.length && 
            finalInsurances?.map(
              (insurance, key) =>
                key === 3 && (
                  <Grid key={key} item>
                    <BannerHome
                      insuranceId={insurance.productTypeId}
                      insuranceName={insurance.description.toUpperCase()}
                      insuranceCompany={insurance.insuranceCompanies[0]}
                    />
                  </Grid>
                )
            )}
          {finalInsurances.length > 0 &&
            finalInsurances.map(
              (insurance, key) =>
                key === 3 && (
                  <Grid key={key} item>
                    <InsuranceCard
                      insuranceId={insurance.productTypeId}
                      insuranceName={insurance.description.toUpperCase()}
                      insuranceCompany={insurance.insuranceCompanies[0]}
                    />
                  </Grid>
                )
            )}
          {finalInsurances.map(
            (insurance, key) =>
              key !== 3 && (
                <Grid key={key} item>
                  <InsuranceCard
                    insuranceId={insurance.productTypeId}
                    insuranceName={insurance.description.toUpperCase()}
                    insuranceCompany={insurance.insuranceCompanies[0]}
                  />
                </Grid>
              )
          )}
        </Grid>
      )}
    </>
  );
}
